export class CFSManifestReleaseOption  {
    id: number = 0;
    companyId: number = 0;
    requestDept: string = '';
    contact: string = '';
    email: string = '';
}
